<article
	class="reference"
	(click)="showDocument(reference)"
>
	<div class="reference__content">
		<app-svg-document-one-list
			class="reference__image"
			width="30px"
			heigth="30px"
		></app-svg-document-one-list>
		<div class="reference__info">
			<h2 class="reference__title">
				{{ reference.referenceName }} от {{ reference.createDate | date: 'dd.MM.yyyy' }}
			</h2>
			<p class="reference__expire-date">
				Хранится до {{ reference.expireDate | date: 'dd.MM.yyyy' }}
			</p>
			@if (reference.caption) {
				<p class="reference__caption">
					{{ reference.caption }}
				</p>
			}
		</div>
	</div>

	@if (documentPending$$ | async) {
		<div class="reference__loader">
			<app-round-loader></app-round-loader>
		</div>
	}
</article>
